import { useContext, useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { LegalTexts } from "../components/LegalTexts";
import { t } from "../i18n";

export const BookingEnd = () => {
	const nextPage = "thankYouPage";
	const previousPage = "selectDateTime";

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const {
		flow,
		data,
		setData,
		companies,
		setCompanies,
		isTransitioning,
		errors,
	} = useContext(AppContext);

	useEffect(() => {
		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		if (data.locator) {
			fetch(`${apiUrl}/query/companies?locator=${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setCompanies(newData.companies);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data.locator, setCompanies]);

	return (
		<div
			className={
				"content booking_end kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_booking_form">
				<div className="booking_form_title">
					<h2>
						<strong>
							{t(
								"Solo necesitamos estos datos para confirmar tu cita"
							)}
						</strong>
					</h2>
					<span>
						{t("Confirma tu cita para tu")}
						<strong>{" " + data.brand + " " + data.model}</strong>
					</span>
				</div>

				<div className="booking_form_content">
					<div className="booking_form_vehicle">
						<p>{t("Datos del vehículo")}</p>
						<form>
							<label>
								<strong>{t("Matrícula")}</strong>
								<input
									type="text"
									defaultValue={data ? data.plate : ""}
									onChange={(e) =>
										setData({
											...data,
											plate: e.target.value,
										})
									}
								/>
								{errors.plate && (
									<span className="error">
										{errors.plate}
									</span>
								)}
							</label>
							{flow === "web" && (
								<>
									<label>
										<strong>{t("Aseguradora")}</strong>
										<select
											value={data?.insurance || ""}
											onChange={(e) =>
												setData({
													...data,
													insurance: e.target.value,
												})
											}
											disabled={data?.noInsurance}
										>
											<option value="">
												{t("Elige tu seguro")}
											</option>
											{companies &&
												companies.map(
													(company, index) => (
														<option
															key={index}
															value={company}
														>
															{company}
														</option>
													)
												)}
										</select>
										{errors.insurance && (
											<span className="error">
												{errors.insurance}
											</span>
										)}
									</label>
									<label className="no_insurance">
										<input
											type="checkbox"
											checked={
												!!(data && data.noInsurance)
											}
											onChange={(e) =>
												setData({
													...data,
													noInsurance:
														e.target.checked,
													insurance: e.target.checked
														? ""
														: data.insurance,
												})
											}
										/>
										{t("No tengo aseguradora")}
									</label>
								</>
							)}
						</form>
					</div>

					<div className="booking_form_user">
						<p>{t("Tus datos")}</p>
						<form>
							<label>
								<strong>{t("Email")}</strong>
								<input
									type="email"
									defaultValue={data ? data.email : ""}
									onChange={(e) =>
										setData({
											...data,
											email: e.target.value,
										})
									}
								/>
								{errors.email && (
									<span className="error">
										{errors.email}
									</span>
								)}
							</label>
							<label>
								<strong>{t("Nombre y Apellidos")}</strong>
								<input
									type="text"
									defaultValue={data ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.target.value,
										})
									}
								/>
								{errors.name && (
									<span className="error">{errors.name}</span>
								)}
							</label>
							<label>
								<strong>{t("Teléfono")}</strong>
								<input
									type="tel"
									defaultValue={data ? data.phone : ""}
									onChange={(e) =>
										setData({
											...data,
											phone: e.target.value,
										})
									}
								/>
								{errors.phone && (
									<span className="error">
										{errors.phone}
									</span>
								)}
							</label>
							<label className="privacy_policy">
								<input
									type="checkbox"
									checked={!!(data && data.privacy_policy_2)}
									onChange={(e) =>
										setData({
											...data,
											privacy_policy_2: e.target.checked,
										})
									}
								/>
								<span className="link">
									{t("Acepto la")}{" "}
									<a
										href="https://www.ralarsa.com/es/privacidad/"
										target="_blank"
										rel="noopener noreferrer"
									>
										{t("política de privacidad")}
									</a>
								</span>
							</label>
						</form>
					</div>
					<LegalTexts />
				</div>
			</div>
		</div>
	);
};
